import * as THREE from 'three';
import { disposeO3D } from './threejsHelper';
import { createSpriteText } from '@/utils/labeltext.js'
import { createSpriteEnum } from '@/utils/labeltextEnumType'
import {
  createObstaclePolygon,
  loadFontModel,
  loadModel,
  create_trajectory,
} from './vehicleHelper';
import { getObstacleType } from '@/utils/enumHelper.js';


let obstacleO3D_box = new Map();
let obstacleO3D_polygon = new Map();
let obstacleLabelMap = new Map();
let obstacleRotationMap = new Map();
let obstacleModelMap = new Map();
let obstacle_trajectory_map = new Map();

let obstacleO3D_box_visible = true;
let obstacleO3D_polygon_visible = true;
let obstacle_Label_visible = true;
let obstacleModelMap_visible = true;

let elementSetting = null;
let scene = null;
let rotaZCamera = null;
const material_obstacleRotationMap = new THREE.MeshBasicMaterial({
  color: 0x7a1723,
});
let obstacle_reserve_index = 5;

let material_box = new THREE.LineBasicMaterial({ color: 0x7a1723 });
let material_box_erased = new THREE.LineDashedMaterial({
  color: 0x808080,
  dashSize: 0.4,
  gapSize: 0.2,
});
const ERASE_OBSTACLE_CHANNEL = '/businessResult/eraseObstacles';
let obstacl_label_local_static = false;
// /ganzhiConfig/ObstacleNegType/
let negligibleTypeList = [];

/**
 * 加载主车附近的障碍物
 */
export const loadObstacle = (
  vehicleData,
  scene_param,
  obstacleLabelMap_param,
  rotaZCamera_param,
  elementSetting_param,
) => {
  if (vehicleData.obstacleList.length == 0) {
    obstacle_reserve_index--;
    if (obstacle_reserve_index > 0) {
      return;
    }
  }
  let vehicleDataEx = {
    obstacleList: vehicleData.obstacleList?.filter(item => negligibleTypeList.includes('/ganzhiConfig/ObstacleNegType/' + item.negligibleType)),
    origin: vehicleData.origin
  }
  const erasedIds = getErasedObstacleIds(vehicleData);
  vehicleDataEx.obstacleList?.forEach((item) => {
    item.erased = erasedIds.has(String(item.id));
  });
  obstacle_reserve_index = 5;

  scene = scene_param;
  obstacleLabelMap = obstacleLabelMap_param;
  rotaZCamera = rotaZCamera_param;
  elementSetting = elementSetting_param;
  load_obstacle_polygon(vehicleDataEx);
  load_obstacle_box(vehicleDataEx);
  load_obstacle_label(vehicleDataEx);
  load_obstacle_trajectory(vehicleDataEx);
};

/**
 * 获取某类型的障碍物，在场景中显示的group
 */
const getObstacleGroup = (typeValue) => {
  let item = getObstacleType().find((e) => e.key == typeValue);
  if (item) {
    let setting = elementSetting.obstacle[item.eName];
    if (setting) {
      if (!setting.group) {
        setting.group = new THREE.Group();
        setting.group.visible = setting.visible;
        setting.group.position.set(0, 0, 0.022);
        scene.add(setting.group);
      }
      return setting.group;
    }
  }
};

/**
 * 加载障碍物文本
 */
const getLabelForObstacle = (obstacle, origin) => {
  let obstacleCenter = getCenterForObstacle(obstacle);
  let center = {
    x: origin.x + obstacleCenter.x,
    y: origin.y + obstacleCenter.y,
  };
  if (obstacleLabelMap.has(obstacle.id)) {
    let model = obstacleLabelMap.get(obstacle.id);
    if (
      model.obstacleType == obstacle.obstacleType &&
      model.speed == obstacle.speed &&
      !!model.erased === !!obstacle.erased
    ) {
      if (model.speed > 0 || obstacleCenter.x < 30 || obstacleCenter.y < 30) {
        model.position.set(
          center.x,
          center.y,
          obstacle.polygon?.center?.position?.z -
          obstacle.height / 2 +
          obstacle.height +
          0.5,
        );
        return;
      }
    }
    obstacleLabelMap.delete(obstacle.id);
    model.visible = false;
    disposeO3D(model);
  }

  let item = getObstacleType().find((e) => e.key == obstacle.obstacleType);
  if (item) {
    if (obstacle.speed) {
      let text_list = [];
      let lineColors = null;
      text_list.push('ID:' + obstacle.id);
      text_list.push(obstacle.erased ? `Type:${item.eName}（被忽略）` : `Type:${item.eName}`);
      if (obstacle.erased) {
        lineColors = ['#ed1941', '#ffffff'];
      }
      if (obstacle.speed != 0) {
        text_list.push('Speed:' + financial(obstacle.speed, 2));
        if (lineColors) {
          lineColors.push('#ed1941');
        }
      }
      let labelGroup = createSpriteText(text_list, 50, '#ed1941', 400, 800, lineColors);
      let label_group = new THREE.Group();
      label_group.name = "obstacle_label_group";
      label_group.obstacleid = obstacle.id
      label_group.deleteIndex = 4;
      label_group.add(labelGroup);
      label_group.position.set(
        center.x,
        center.y,
        obstacle.polygon?.center?.position?.z + obstacle.height / 2 + 0.2
      );
      let group = getObstacleGroup(obstacle.obstacleType);
      if (group) {
        if (!obstacleLabelMap.has(obstacle.id)) {
          group.add(label_group);
          label_group.obstacleType = obstacle.obstacleType;
          label_group.speed = obstacle.speed;
          label_group.erased = !!obstacle.erased;
          obstacleLabelMap.set(obstacle.id, label_group);
        } else {
        }
      }
    } else {

      if (!obstacle.erased && !obstacl_label_local_static) return
      if (obstacleCenter.x > 30 || obstacleCenter.y > 30) return;
      const labelText = obstacle.erased ? `${item.label}（被忽略）` : item.label;
      let labelGroup = createSpriteEnum(labelText, obstacle.erased ? { color: '#ffffff' } : {});
      let label_group = new THREE.Group();
      label_group.name = "obstacle_label_group";
      label_group.obstacleid = obstacle.id
      label_group.deleteIndex = 4;
      label_group.add(labelGroup);
      label_group.position.set(
        center.x,
        center.y,
        obstacle.polygon?.center?.position?.z + 0.05
      );
      let group = getObstacleGroup(obstacle.obstacleType);
      if (group) {
        if (!obstacleLabelMap.has(obstacle.id)) {
          group.add(label_group);
          label_group.obstacleType = obstacle.obstacleType;
          label_group.speed = obstacle.speed;
          label_group.erased = !!obstacle.erased;
          obstacleLabelMap.set(obstacle.id, label_group);
        } else {
        }
      }
    }
  }
};


const getObstacleRotation = (obstacle, origin) => {
  let obstacleCenter = getCenterForObstacle(obstacle);
  let center = {
    x: origin.x + obstacleCenter.x,
    y: origin.y + obstacleCenter.y,
  };
  if (obstacleRotationMap.has(obstacle.id)) {
    let model = obstacleRotationMap.get(obstacle.id);
    model.position.set(
      center.x,
      center.y,
      obstacle.polygon?.center?.position?.z -
      obstacle.height / 2 +
      obstacle.height +
      0.8,
    );
    model.visible = obstacle.speed > 0;
    model.rotation.z = obstacle.speedHeading - Math.PI / 2;
  } else {
    if (obstacle.speed == 0) return;
    let element = createArrows(obstacle.obstacleType);
    element.position.set(
      center.x,
      center.y,
      obstacle.polygon?.center?.position?.z -
      obstacle.height / 2 +
      obstacle.height +
      0.8,
    );
    element.rotation.z = obstacle.speedHeading - Math.PI / 2;

    let group = getObstacleGroup(obstacle.obstacleType);
    if (group) {
      if (!obstacleRotationMap.has(obstacle.id)) {
        obstacleRotationMap.set(obstacle.id, element);
        group.add(element);
      } else {
        let dis = obstacleRotationMap.get(obstacle.id);
        disposeO3D(dis);
        obstacleRotationMap.set(obstacle.id, element);
        group.add(element);
      }
    }
  }
};

/**
 * 加载障碍物模型
 */
const getModelForObstacle = (obstacle, origin) => {
  let obstacleCenter = getCenterForObstacle(obstacle);
  let center = {
    x: origin.x + obstacleCenter.x,
    y: origin.y + obstacleCenter.y,
  };
  let rotationZ = obstacle.polygon?.center?.orientation?.z;
  if (obstacleModelMap.has(obstacle.id)) {
    let model = obstacleModelMap.get(obstacle.id);
    if (model.obstacleType == obstacle.obstacleType) {
      let { length, height, width } = obstacle;

      if (rotationZ && model.rotationInit) {
        if (model.rotationInit.axis == 'y') {
          model.rotation.set(
            model.rotationInit.x,
            model.rotationInit.y + rotationZ,
            model.rotationInit.z,
          );
          model.scale.set(
            width / model.size.y,
            height / model.size.z,
            length / model.size.x,
          );
          // model.scale.set(length / model.size.x,width / model.size.y,height / model.size.z)
        } else {
          model.rotation.set(
            model.rotationInit.x,
            model.rotationInit.y,
            model.rotationInit.z + rotationZ,
          );
          model.scale.set(
            length / model.size.x,
            width / model.size.y,
            height / model.size.z,
          );
        }
      }
      // model.scale.set(length / model.size.x, height / model.size.y, width / model.size.z)
      model.position.set(
        center.x,
        center.y,
        obstacle.polygon?.center?.position?.z - obstacle.height / 2,
      );
      return;
    } else {
      obstacleModelMap.delete(obstacle.id);
      disposeO3D(model);
    }
  }
  loadModel(obstacle, (model) => {
    model.position.set(
      center.x,
      center.y,
      obstacle.polygon?.center?.position?.z - obstacle.height / 2,
    );
    let group = getObstacleGroup(obstacle.obstacleType);
    if (group) {
      if (!obstacleModelMap.has(obstacle.id)) {
        let { length, height, width } = obstacle;
        if (rotationZ && model.rotationInit) {
          if (model.rotationInit.axis == 'y') {
            model.rotation.set(
              model.rotationInit.x,
              model.rotationInit.y + rotationZ,
              model.rotationInit.z,
            );
            model.scale.set(
              width / model.size.y,
              height / model.size.z,
              length / model.size.x,
            );
          } else {
            model.rotation.set(
              model.rotationInit.x,
              model.rotationInit.y,
              model.rotationInit.z + rotationZ,
            );
            model.scale.set(
              length / model.size.x,
              width / model.size.y,
              height / model.size.z,
            );
          }
        }
        // model.scale.set(length / model.size.x, width / model.size.z, height / model.size.y)
        group.add(model);
        model.obstacleType = obstacle.obstacleType;
        obstacleModelMap.set(obstacle.id, model);
      }
    }
  });
};

//获取障碍物中心位置
const getCenterForObstacle = (obstacle) => {
  if (obstacle?.polygon?.center?.position) {
    return obstacle?.polygon?.center?.position;
  } else {
    return { x: 0, y: 0 };
  }
};

const createArrows = (type) => {
  let radius = 0.2;
  switch (type) {
    case 1:
      radius += 0.1;
      break;
    case 2:
    case 3:
      radius += 0.4;
      break;
    default:
      break;
  }
  const geometry = new THREE.ConeGeometry(radius, radius * 2, 32);
  const element = new THREE.Mesh(geometry, material_obstacleRotationMap);
  {
    const geometry = new THREE.CylinderGeometry(
      radius / 4,
      radius / 4,
      radius * 6,
      32,
    );
    const cylinder = new THREE.Mesh(geometry, material_obstacleRotationMap);
    cylinder.position.set(0, -radius * 3, 0);
    element.add(cylinder);
  }
  return element;
};

const clearGroupMap = (map) => {
  for (let [key, model] of map) {
    model.visible = false;
    disposeO3D(model);
  }
  map.clear();
};
export const clearObstacle = () => {
  clearGroupMap(obstacleO3D_box);
  clearGroupMap(obstacleO3D_polygon);
  clearGroupMap(obstacleLabelMap);
  clearGroupMap(obstacleRotationMap);
  clearGroupMap(obstacleModelMap);
};

export const obstacleLabel_visible = (menuList, ObjectNegligibleTypeList) => {
  obstacl_label_local_static = menuList;
  negligibleTypeList = ObjectNegligibleTypeList
};

/**
 * 加载障碍物的polygon
 */
export const load_obstacle_polygon = (vehicleData) => {
  clearGroupMap(obstacleO3D_polygon);
  if (!obstacleO3D_polygon_visible) return;
  let visible = localStorage.getItem('polygon_local') == "1"
  if (!visible) return;
  vehicleData.obstacleList.forEach((e) => {
    let obstacleModel_polygon = createObstaclePolygon(
      e,
      vehicleData.origin,
      (data) => { },
    );
    if (obstacleModel_polygon) {
      let group = getObstacleGroup(e.obstacleType);
      if (group) {
        obstacleModel_polygon.position.set(
          0,
          0,
          e.polygon?.center?.position?.z - e.height / 2,
        );
        group.add(obstacleModel_polygon);
        obstacleO3D_polygon.set(e.id, obstacleModel_polygon);
      }
    }
  });
};
/**
 * 加载障碍物的box
 */
export const load_obstacle_box = (vehicleData) => {
  if (!obstacleO3D_box_visible) {
    clearGroupMap(obstacleO3D_box);
    return;
  }
  for (let [key, group] of obstacleO3D_box) {
    let ele = vehicleData.obstacleList.find((element) => element.id == key);
    if (!ele) {
      obstacleO3D_box.delete(key);
      disposeO3D(group);
    }
  }
  for (let i = 0; i < vehicleData.obstacleList.length; i++) {
    let e = vehicleData.obstacleList[i];
    let boxHas = obstacleO3D_box.has(e.id);
    let { position, orientation } = e.polygon.center;
    if (!boxHas) {
      let box = createBox(e);
      let group = getObstacleGroup(e.obstacleType);
      if (group) {
        box.position.set(
          vehicleData.origin.x + position.x,
          vehicleData.origin.y + position.y,
          position.z,
        );
        box.rotation.set(orientation.x, orientation.y, orientation.z);
        group.add(box);
        obstacleO3D_box.set(e.id, box);
      }
    } else {
      let box = obstacleO3D_box.get(e.id);
      let isChange = changeBox(box, e);
      if (isChange) {
        disposeO3D(box);
        box = createBox(e);
        let group = getObstacleGroup(e.obstacleType);
        if (group) {
          group.add(box);
          obstacleO3D_box.set(e.id, box);
        }
      }
      box.material = getBoxMaterial(e);
      if (e.erased) {
        box.computeLineDistances();
      }
      box.position.set(
        vehicleData.origin.x + position.x,
        vehicleData.origin.y + position.y,
        position.z,
      );
      box.rotation.set(orientation.x, orientation.y, orientation.z);
    }
  }
  // vehicleData.obstacleList.forEach((e) => {
  //     let boxHas = obstacleO3D_box.has(e.id);
  //     let { position, orientation } = e.polygon.center;
  //     if (!boxHas) {
  //         let box = createBox(e);
  //         let group = getObstacleGroup(e.obstacleType)
  //         if (group) {
  //             box.position.set(vehicleData.origin.x + position.x, vehicleData.origin.y + position.y, position.z)
  //             box.rotation.set(orientation.x, orientation.y, orientation.z)
  //             group.add(box)
  //             obstacleO3D_box.set(e.id, box)
  //         }
  //     } else {
  //         let box = obstacleO3D_box.get(e.id);
  //         let isChange = changeBox(box, e);
  //         if (isChange) {
  //             disposeO3D(box);
  //             box = createBox(e);
  //             let group = getObstacleGroup(e.obstacleType)
  //             if (group) {
  //                 group.add(box)
  //                 obstacleO3D_box.set(e.id, box)
  //             }
  //         }
  //         box.position.set(vehicleData.origin.x + position.x, vehicleData.origin.y + position.y, position.z)
  //         box.rotation.set(orientation.x, orientation.y, orientation.z)
  //     }
  // })
};
const changeBox = (box, obstacle) => {
  let {
    size: { length, height, width },
  } = box;
  return (
    length != financial(obstacle.length) ||
    width != financial(obstacle.width) ||
    height != financial(obstacle.height)
  );
};
function getBoxMaterial(obstacle) {
  return obstacle?.erased ? material_box_erased : material_box;
}

function getErasedObstacleIds(vehicleData) {
  const ids = new Set();
  if (!localStorage.getItem('topicChannelChecks')?.includes(ERASE_OBSTACLE_CHANNEL)) {
    return ids;
  }
  const freeMoveCommand = vehicleData.businessResult?.remoteBusinessCommand?.remoteTakeoverCommand?.freeMoveCommand;
  const list = (freeMoveCommand?.historyPreview?.environmentEdit || freeMoveCommand?.preview?.environmentEdit)?.eraseObstaclesList;
  list?.forEach((item) => {
    if (item?.id !== undefined && item?.id !== null) {
      ids.add(String(item.id));
    }
  });
  return ids;
}

function createBox(obstacle) {
  let { length, height, width } = obstacle;
  const geometry = new THREE.BoxGeometry(length, width, height);
  const edges = new THREE.EdgesGeometry(geometry);
  const box = new THREE.LineSegments(edges, getBoxMaterial(obstacle));
  box.size = {
    width: financial(width),
    length: financial(length),
    height: financial(height),
  };
  if (obstacle?.erased) {
    box.computeLineDistances();
  }
  return box;
}
function financial(x, digits = 3) {
  return Number.parseFloat(x).toFixed(digits);
}
export const load_obstacle_label = (vehicleData) => {
  let obstacle_Label_visible = localStorage.getItem('obstacl_label_local') == "1"
  if (!obstacle_Label_visible) {
    clearGroupMap(obstacleLabelMap);
    clearGroupMap(obstacleRotationMap);
    return;
  }
  for (let [key, group] of obstacleLabelMap) {
    let ele = vehicleData.obstacleList.find((element) => element.id == key);
    if (!ele) {
      obstacleLabelMap.delete(key);
      disposeO3D(group);
    }
  }
  for (let [key, group] of obstacleRotationMap) {
    let ele = vehicleData.obstacleList.find((element) => element.id == key);
    if (!ele) {
      obstacleRotationMap.delete(key);
      disposeO3D(group);
    }
  }
  vehicleData.obstacleList.forEach((e) => {
    getLabelForObstacle(e, vehicleData.origin);
    getObstacleRotation(e, vehicleData.origin);
  });
};

export const load_obstacle_model = (vehicleData) => {
  if (!obstacleModelMap_visible) {
    clearGroupMap(obstacleModelMap);
    return;
  }
  for (let [key, group] of obstacleModelMap) {
    let ele = vehicleData.obstacleList.find((element) => element.id == key);
    if (!ele) {
      obstacleModelMap.delete(key);
      disposeO3D(group);
    }
  }
  for (let i = 0; i < vehicleData.obstacleList.length; i++) {
    let e = vehicleData.obstacleList[i];
    getModelForObstacle(e, vehicleData.origin);
  }
  // vehicleData.obstacleList.forEach((e) => {
  //     getModelForObstacle(e, vehicleData.origin);
  // })
};

/**
 * 规划线
 * @param {*} obstacle
 * @param {*} origin
 * @returns
 */
const load_obstacle_trajectory = (vehicleData) => {
  clearGroupMap(obstacle_trajectory_map);

  for (let i = 0; i < vehicleData.obstacleList.length; i++) {
    let e = vehicleData.obstacleList[i];
    let trajectory = create_trajectory(e, vehicleData.origin);

    if (trajectory) {
      let group = getObstacleGroup(e.obstacleType);

      if (group) {
        group.add(trajectory);
        obstacle_trajectory_map.set(e.id, trajectory);
      }
    }
  }
  // vehicleData.obstacleList.forEach((e) => {
  //     let trajectory = create_trajectory(e, vehicleData.origin)
  //     if (trajectory) {
  //         let group = getObstacleGroup(e.obstacleType)
  //         if (group) {
  //             group.add(trajectory)
  //             obstacle_trajectory_map.set(e.id, trajectory)
  //         }
  //     }
  // })
};

let lebalTexture_toal = null;
function initLabelTexture() {
  // 预渲染所有枚举文本到一张纹理
  const enumTexts = ["TYPE1", "TYPE2", "TYPE3"]; // 你的枚举值
  const canvas = new OffscreenCanvas(256, 256);
  const ctx = canvas.getContext('2d');

  // 清空背景（透明）
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // 绘制文本（白色）
  ctx.fillStyle = 'white';
  ctx.font = '20px Arial';
  enumTexts.forEach((text, i) => {
    ctx.fillText(text, 10, 30 + i * 40); // 纵向排列，间距40px
  });

  lebalTexture_toal = new THREE.CanvasTexture(canvas);
  lebalTexture_toal.needsUpdate = true;
}

function createLabel(type) {
  // 为每个 Box 创建 Sprite（共享同一纹理）
  if (!lebalTexture_toal) {
    initLabelTexture();
  }
  const material = new THREE.SpriteMaterial({
    map: initLabelTexture,
    transparent: true,
    alphaTest: 0.1 // 剔除透明像素
  });

  // 2. 创建 Sprite
  const label = new THREE.Sprite(material);

  // 3. 设置 Sprite 位置（相对于 Box）
  label.position.copy(box.position);
  label.position.y += box.geometry.parameters.height / 2 + 0.5; // 显示在 Box 上方

  // 4. 存储枚举索引（用于 UV 偏移）
  label.userData.enumIndex = index % enumTexts.length; // 循环分配枚举值
}
